export default "__VITE_PUBLIC_ASSET__8eb9233b__"